/* tslint:disable */
/* eslint-disable */
/**
 * POS API
 * Internal POS API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetConfig200ResponsePaymentMethodsConfigInner
 */
export interface GetConfig200ResponsePaymentMethodsConfigInner {
    /**
     * 
     * @type {string}
     * @memberof GetConfig200ResponsePaymentMethodsConfigInner
     */
    name: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponsePaymentMethodsConfigInner
     */
    openDrawer: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponsePaymentMethodsConfigInner
     */
    availableForDelivery: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof GetConfig200ResponsePaymentMethodsConfigInner
     */
    availableForShift: boolean;
    /**
     * 
     * @type {number}
     * @memberof GetConfig200ResponsePaymentMethodsConfigInner
     */
    position: number;
    /**
     * 
     * @type {any}
     * @memberof GetConfig200ResponsePaymentMethodsConfigInner
     */
    configs?: any | null;
}

/**
 * Check if a given object implements the GetConfig200ResponsePaymentMethodsConfigInner interface.
 */
export function instanceOfGetConfig200ResponsePaymentMethodsConfigInner(value: object): value is GetConfig200ResponsePaymentMethodsConfigInner {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('openDrawer' in value) || value['openDrawer'] === undefined) return false;
    if (!('availableForDelivery' in value) || value['availableForDelivery'] === undefined) return false;
    if (!('availableForShift' in value) || value['availableForShift'] === undefined) return false;
    if (!('position' in value) || value['position'] === undefined) return false;
    return true;
}

export function GetConfig200ResponsePaymentMethodsConfigInnerFromJSON(json: any): GetConfig200ResponsePaymentMethodsConfigInner {
    return GetConfig200ResponsePaymentMethodsConfigInnerFromJSONTyped(json, false);
}

export function GetConfig200ResponsePaymentMethodsConfigInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetConfig200ResponsePaymentMethodsConfigInner {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'openDrawer': json['openDrawer'],
        'availableForDelivery': json['availableForDelivery'],
        'availableForShift': json['availableForShift'],
        'position': json['position'],
        'configs': json['configs'] == null ? undefined : json['configs'],
    };
}

export function GetConfig200ResponsePaymentMethodsConfigInnerToJSON(json: any): GetConfig200ResponsePaymentMethodsConfigInner {
    return GetConfig200ResponsePaymentMethodsConfigInnerToJSONTyped(json, false);
}

export function GetConfig200ResponsePaymentMethodsConfigInnerToJSONTyped(value?: GetConfig200ResponsePaymentMethodsConfigInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'openDrawer': value['openDrawer'],
        'availableForDelivery': value['availableForDelivery'],
        'availableForShift': value['availableForShift'],
        'position': value['position'],
        'configs': value['configs'],
    };
}

